import { stats } from "@/mocks/heigua";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-ink-950">
      {/* 背景图 + 压暗 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=a%20single%20vintage%20steel%20vault%20door%20with%20one%20thin%20glowing%20warm%20amber%20seam%20of%20light%20at%20the%20center%20of%20a%20pitch%20black%20concrete%20chamber%20deep%20charcoal%20shadows%20mysterious%20hidden%20secret%20room%20cinematic%20dramatic%20hard%20lighting%20subtle%20dust%20particles%20floating%20high%20contrast%20editorial%20noir%20photography%20film%20grain%20premium%20magazine%20art%20direction%20no%20text%20no%20watermark&width=1800&height=1000&seq=heigua-hero&orientation=landscape"
          alt="吃瓜黑屋加密专区入口暗门"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/85 via-ink-950/70 to-ink-950" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink-950/70 via-transparent to-ink-950/50" />
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6 pb-16 pt-44 md:pb-24 md:pt-56">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-cream-50/20 bg-cream-50/5 px-4 py-1.5 text-xs tracking-wide text-cream-50/85 backdrop-blur-sm">
            <i className="ri-fire-fill text-ember-500" />
            内部爆料 · 独家内幕 · 私密分享，正在实时归档
          </div>

          <h1 className="font-serif text-4xl font-bold leading-tight tracking-tight text-cream-50 md:text-6xl">
            吃瓜黑屋
            <span className="mx-2 md:mx-3 text-ember-500">·</span>
            <span className="block mt-2 text-2xl font-medium md:mt-3 md:text-4xl text-cream-50/95">
              全网挖不到的瓜，都在这里开锁
            </span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-cream-50/75 md:text-lg">
            汇集<span className="text-cream-50 font-medium">内部爆料</span>与
            <span className="text-cream-50 font-medium">独家内幕</span>，私密分享的
            <span className="text-cream-50 font-medium">隐藏内容</span>持续更新。
            点开即入<span className="text-ember-400 font-medium">加密专区</span>，翻阅未公开的深度素材与热门瓜料。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#vault"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-ember-500 px-7 py-3.5 text-sm font-semibold text-cream-50 hover:bg-ember-600 sm:w-auto"
            >
              <i className="ri-lock-2-line mr-2 text-base" />
              进入加密专区
            </a>
            <a
              href="#feed"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-cream-50/30 bg-cream-50/5 px-7 py-3.5 text-sm font-semibold text-cream-50 backdrop-blur-sm hover:border-cream-50/60 hover:bg-cream-50/10 sm:w-auto"
            >
              看今日瓜报
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>

          <p className="mt-5 flex items-center justify-center gap-2 text-xs text-cream-50/55">
            <i className="ri-shield-check-line text-leaf-500" />
            素材经溯源校验后归档 · 加密素材设时效水印
          </p>
        </div>

        {/* 数据条 */}
        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-px overflow-hidden rounded-xl bg-cream-50/10 sm:grid-cols-4 md:mt-20">
          {stats.map((s) => (
            <div key={s.label} className="bg-ink-900/40 px-4 py-5 text-center backdrop-blur-sm">
              <div className="font-serif text-2xl font-bold text-cream-50 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-cream-50/60">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}